import React from 'react';
import Header from '../components/header'; 
import Footer from '../components/footer'; 

const Services = () => {
  return (
    <div>
        <Header />
	<div className="section big-55-height over-hide z-bigger">
	
		<div className="parallax parallax-top" style={{ backgroundImage: `url('/img/22.jpeg')` }}></div>
		<div className="dark-over-pages"></div>
	
		<div className="hero-center-section pages">
			<div className="container">
				<div className="row justify-content-center">
					<div className="col-12 parallax-fade-top">
						<div className="hero-text">Services</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	
	 
	
	 <div className="section padding-top-bottom over-hide">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-8 align-self-center">
                    <div className="subtitle with-line text-center mb-4">Experience Exceptional Services</div>
                    <h3 className="text-center padding-bottom-small"> At Our Hotel In Rourkela</h3>
                </div>
                <div className="section clearfix"></div>
                <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center">
                        <img src="img/icons/booking.png" alt=""/>
                        <h5 className="mt-1">No Booking fees</h5>
                        <p className="mt-3 text-justify">Enjoy complete transparency with our no booking fees policy, ensuring you pay only for your stay without any hidden or extra charges.</p>
                       
                    </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center">
                        <img src="img/icons/best-price.png" alt=""/>
                        <h5 className="mt-1">Best rate guarantee</h5>
                        <p className="mt-3  text-justify">Benefit from our best rate guarantee, offering you the most competitive prices and unmatched value whenever you book directly with us.</p>
                       
                    </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center">
                        <img src="img/icons/reservation.png" alt=""/>
                        <h5 className="mt-1">Reservation 24/7</h5>
                        <p className="mt-3  text-justify">Enjoy round-the-clock reservation support, allowing you to book your stay anytime with ease, convenience, and reliable assistance whenever you need it.</p>
                       
                    </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center">
                        <img src="img/icons/wifi.png" alt=""/>
                        <h5 className="mt-1">High Speed WIFI</h5>
                        <p className="mt-3  text-justify">Stay connected with our high-speed Wi-Fi, offering seamless browsing, smooth streaming, and uninterrupted access throughout your entire stay.</p>
                       
                    </div>
                </div>
                <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center">
                        <img src="img/6.svg" alt=""/>
                        <h5 className="mt-2">Dining</h5>
                        <p className="mt-3  text-justify">Savor a delightful dining experience with freshly prepared dishes, rich flavors, and a welcoming ambiance crafted to satisfy every palate.</p>
                       
                    </div>
                </div>
                  <div className="col-sm-6 col-lg-4">
                    <div className="services-box text-center cll">
                        <img src="img/icons/no-smoking.png" alt=""/>
                        <h5 className="mt-2">No Smoking</h5>
                        <p className="mt-3  text-justify">Savor a delightful dining experience with freshly prepared dishes, rich flavors, and a welcoming ambiance crafted to satisfy every palate.</p>
                       
                    </div>
                </div>
               
                 
            </div>
        </div>
    </div>
	
	<section className="amenities-section py-5">
    <div className="container">

        <div className="text-center mb-5">
            <h2 className="amenities-title">Our Amenities</h2>
            <p className="amenities-sub">Comfort, luxury, and everything you need during your stay.</p>
        </div>

        <div className="row g-4 justify-content-center">

            <div className="col-6 col-sm-6 col-md-4 col-lg-2">
                <div className="amenity-card">
                    <img src="img/icons/1.svg" alt=""/>
                    <p>No Smoking</p>
                </div>
            </div>

            <div className="col-6 col-sm-6 col-md-4 col-lg-2">
                <div className="amenity-card">
                    <img src="img/icons/2.svg" alt=""/>
                    <p>Big Beds</p>
                </div>
            </div>

            <div className="col-6 col-sm-6 col-md-4 col-lg-2">
                <div className="amenity-card">
                    <img src="img/icons/3.svg" alt=""/>
                    <p>Free Wi-Fi</p>
                </div>
            </div>

            <div className="col-6 col-sm-6 col-md-4 col-lg-2">
                <div className="amenity-card">
                    <img src="img/icons/4.svg" alt=""/>
                    <p>Free Drinks</p>
                </div>
            </div>

            <div className="col-6 col-sm-6 col-md-4 col-lg-2">
                <div className="amenity-card">
                    <img src="img/icons/6.svg" alt=""/>
                    <p>Room Breakfast</p>
                </div>
            </div>

        </div>
    </div>
</section>

	
	<div className="section padding-top-bottom background-grey over-hide">
		<div className="container">
			<div className="row justify-content-center">
				<div className="col-md-8 align-self-center">
					<div className="subtitle with-line text-center mb-4">Excellent services</div>
					<h3 className="text-center padding-bottom-small">what we offer</h3>
				</div>
				<div className="section clearfix"></div>
			</div>
			 
			<div className="row background-white p-0 m-0">
				<div className="col-xl-6 p-0 align-self-center">
					<div className="row justify-content-center">
						<div className="col-9 pt-4 pt-xl-0 pb-5 pb-xl-0 text-center">
							<h5 className="">restaurant</h5>
							<p className="mt-3">Sed ut perspiciatis unde omnis, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et.</p>
							<a className="mt-1 btn btn-primary" href="/dinein">explore</a>
						</div>
					</div>
				</div>
				<div className="col-xl-6 order-first order-xl-last p-0">
					<div className="img-wrap" id="rev-2">
						<img src="img/ser2.png" alt=""/>
					</div>
				</div>
			</div>
			<div className="row background-white p-0 m-0">
				<div className="col-xl-6 p-0">
					<div className="img-wrap" id="rev-3">
						<img src="img/ser4.png" alt=""/>
					</div>
				</div>
				<div className="col-xl-6 p-0 align-self-center">
					<div className="row justify-content-center">
						<div className="col-9 pt-4 pt-xl-0 pb-5 pb-xl-0 text-center">
							<h5 className="">Banquet</h5>
							<p className="mt-3">Sed ut perspiciatis unde omnis, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et.</p>
							<a className="mt-1 btn btn-primary" href="/banquet">explore</a>
						</div>
					</div>	
				</div>
			</div>
		 
		</div>
	</div>
	
	
    <br></br>
    <Footer />
    </div>
  )
}

export default Services;